import React from 'react'
import { MainInfoContainer } from './MainInfoContainer'
import { DetailedInfoContainer } from './DetailedInfoContainer'
import { PageTitle } from '../../../components/PageTitle'
import { useContext } from './Context'

export const Content = () => {
  const { document } = useContext()

  return (
    <React.Fragment>
      <PageTitle
        title={document?.name || 'Product Details'}
        description={document?.summary || 'View product details and specifications'}
      />
      <MainInfoContainer />
      <DetailedInfoContainer />
    </React.Fragment>
  )
}
